import LayoutContainer from 'components/Common/LayoutContainer'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextButton from 'LuxKit/Button/TextButton'
import Heading from 'LuxKit/Typography/Heading'
import Colour from 'components/utils/Colour'
import Group from 'components/utils/Group'
import { useAppSelector } from 'hooks/reduxHooks'
import LoyaltyProgramNameLogo from 'loyalty/components/LoyaltyProgramNameLogo'
import { rem } from 'polished'
import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

const HeroSection = styled.div`
  padding: ${rem(60)} 0;
  background: ${props => props.theme.palette.product.loyalty.bronze.gradientPrimaryBackground};
`

interface Props {
  onActivate?: () => void
}

function LoyaltyUserBronzeHero(props: Props) {
  const { onActivate } = props
  const intl = useIntl()
  const firstName = useAppSelector(state => state.auth.account.givenName)

  const invitedHeading = intl.formatMessage({
    id: '1BNSgQoTo7',
    defaultMessage: 'You\u2019re invited to join the ultimate rewards program to elevate every escape.',
    description: 'Subheading inviting bronze tier user to join the loyalty rewards program',
  })

  const activateMembershipCta = intl.formatMessage({
    id: 'j1jvLWRGgt',
    defaultMessage: 'Activate your free membership',
    description: 'CTA button to activate free loyalty membership on bronze hero',
  })

  return <HeroSection>
    <LayoutContainer variant="medium">
      <VerticalSpacer gap={16} style={{ position: 'relative' }}>
        <LoyaltyProgramNameLogo width={104} />
        <Group
          direction="vertical"
          tabletDirection="horizontal"
          tabletHorizontalAlign="space-between"
          gap={24}
          tabletGap={16}
        >
          <VerticalSpacer gap={16}>
            <Heading variant="heading1" format="propercase">
              {firstName && <i>{firstName}, </i>}you've unlocked<br />
              <Colour value="tier-bronze-light-contrast">Bronze status</Colour>
              <Heading variant="heading4">
                {invitedHeading}
              </Heading>
            </Heading>
          </VerticalSpacer>
          <Group
            direction="vertical"
            horizontalAlign="start"
            tabletHorizontalAlign="end"
            tabletVerticalAlign="end"
            gap={16}
          >
            <TextButton kind="primary" onClick={onActivate}>
              {activateMembershipCta}
            </TextButton>
          </Group>
        </Group>
      </VerticalSpacer>
    </LayoutContainer>
  </HeroSection>
}

export default LoyaltyUserBronzeHero
